import { allocationResources } from "./allocationResources";
import { administrationResources } from "./administrationResources";
import { configurationResources } from "./configurationResources";
import { masterDataResources } from "./masterDataResources";
import { deliveryResources } from "./deliveryResources";
import { handlingEquipmentResources } from "./handlingEquipmentResources";
import { inventoryResources } from "./inventoryResources";
import { preparationResources } from "./preparationResources";
import { putawayResources } from "./putawayResources";
import { qualityResources } from "./qualityResources";
import { repackagingResources } from "./repackagingResources";
import { stockResources } from "./stockResources";
import { transverseResources } from "./transverseResources";
import { warehouseResources } from "./warehouseResources";
import { outboundOrderResources } from "./outboundOrderResources";
import { dashboardResources } from "./dashboardResources";
import { documentResources } from "./documentResources";
import { translationAdminResources } from "./translationAdminResources";
import { baselineTranslations } from "./baselineTranslations";

export const resources = {
  fr: {
    translation: {
      common: {
        pageActions: "Actions de la page", backAction: "Retour", secondaryAction: "Action secondaire", additionalAction: "Action supplémentaire", searchIn: "Rechercher dans {{module}}", filtersAction: "Filtres",
        home: "Accueil",
        source: "Source",
        destination: "destination",
        destinationLabel: "Destination",
        equipment: "engin",
        client: "client",
        clientLabel: "Client",
        actions: {
          cancel: "Annuler",
          close: "Fermer",
          retry: "Réessayer",
          reconnect: "Se reconnecter",
          continue: "Continuer",
          start: "Démarrer",
          collapse: "Réduire",
          save: "Enregistrer",
          reject: "Rejeter",
          approve: "Approuver"
        },
        filters: {
          search: "Recherche",
          all: "Tous",
          ascending: "Croissant",
          descending: "Décroissant"
        },
        language: { menu: "Langue", french: "Français", english: "English" },
        line: "{{count}} ligne",
        line_other: "{{count}} lignes"
      },
      allocation: allocationResources.fr,
      administration: administrationResources.fr,
      configuration: configurationResources.fr,
      masterData: masterDataResources.fr,
      delivery: deliveryResources.fr,
      handlingEquipment: handlingEquipmentResources.fr,
      inventory: inventoryResources.fr,
      preparation: preparationResources.fr,
      status: {
        WAITING_TRANSFER: "En attente du transfert",
        IN_PROGRESS: "En cours",
        TRANSFERRED: "Transférée",
        COMPLETED: "Terminée",
        COMPLETED_WITH_INCIDENT: "Incident clos",
        CANCELLED: "Annulée",
        EXCEPTION: "Exception",
        OPEN: "Ouverte",
        CREATED: "Créée",
        ASSIGNED: "Affectée",
        LOADING: "À charger",
        READY: "Prête",
        PENDING: "En attente",
        RECEIVED: "Reçue",
        CLOSED: "Clôturée",
        EXPECTED: "Attendue",
        CUSTOMS_PENDING: "Dédouanement",
        ARRIVED: "Arrivée",
        RECEIVING: "Réception en cours",
        POSTING: "À comptabiliser",
        EXPIRED: "Expirée",
        PROPOSED: "Proposée",
        DRAFT: "Brouillon",
        ALLOCATED: "Allouée",
        SUBMITTED: "Soumise",
        ATP_AVAILABLE: "Stock disponible",
        ATP_FAILED: "Stock indisponible",
        FAILED: "Échec",
        PROCESSING: "En cours",
        ACTIVE: "Active",
        AVAILABLE: "Disponible",
        IN_USE: "En utilisation",
        MAINTENANCE: "Maintenance",
        OUT_OF_SERVICE: "Hors service",
        NO_DESTINATION: "Aucune destination",
        ARCHIVED: "Archivée",
        PUBLISHED: "Publié",
        TO_RESOLVE: "À remédier",
        PENDING_APPROVAL: "À valider",
        REMEDIATION: "En remédiation"
      },
      putaway: putawayResources.fr,
      quality: qualityResources.fr,
      repackaging: repackagingResources.fr,
      stock: stockResources.fr,
      transverse: transverseResources.fr,
      warehouse: warehouseResources.fr,
      outboundOrder: outboundOrderResources.fr,
      dashboard: dashboardResources.fr,
      documents: documentResources.fr,
      translationAdmin: translationAdminResources.fr,
      inbound: {
        module: "Réception",
        title: "Réceptions",
        tabs: { open: "Tâches ouvertes", closed: "Tâches clôturées" },
        tabsMobile: { open: "OUVERTES", closed: "CLÔTURÉES" },
        searchPlaceholder: "ASN, réception, fournisseur, client, entrepôt, commande ou statut…",
        receiptStatus: {
          OPEN: "Ouverte", POSTING: "À comptabiliser",
          COMPLETED: "Clôturée", CANCELLED: "Annulée"
        },
        actions: {
          adHoc: "Réception ad hoc",
          newAsn: "Nouvel ASN",
          createAsn: "Créer un ASN",
          markExpected: "Passer à attendu",
          markArrival: "Signaler l’arrivée",
          takeCharge: "Prendre en charge",
          customsRejected: "Dédouanement refusé",
          enterDecision: "Renseigner la décision",
          closeAsn: "Clôturer l’ASN",
          view: "Consulter", select: "Sélectionner", create: "Créer",
          createAndReceive: "Créer et réceptionner", continueReceipt: "Poursuivre la réception",
          editLines: "Modifier les lignes", operations: "Actions et opérations",
          addLine: "Ajouter une ligne", addTheLine: "Ajouter la ligne",
          generateDocument: "Document ASN", generating: "Génération…",
          cancelAsn: "Annuler l’ASN", takeCustoms: "Prendre en charge le dédouanement",
          validateDecision: "Valider la décision", download: "Télécharger",
          saveQuantity: "Enregistrer la quantité", createStock: "Créer le stock et les HU",
          finishReceipt: "Terminer la réception", reopen: "Rouvrir la réception",
          reopenForCorrection: "Rouvrir la réception pour correction"
          , findPo: "Rechercher la PO"
        },
        errors: {
          load: "Impossible de charger les réceptions attendues.",
          statusChange: "Le changement de statut de l’ASN a échoué. Actualisez la liste puis réessayez.",
          lines: "Le détail des lignes n’a pas pu être chargé.",
          partialDetails: "Une partie du détail n’a pas pu être chargée.",
          documentOpen: "Ouverture du document impossible.",
          asnCreate: "Création impossible. Vérifiez le numéro, le fournisseur et l’entrepôt.",
          adHocCreate: "Création impossible. Vérifiez le fournisseur, l’entrepôt, le numéro et le motif.",
          transition: "Transition impossible. Rechargez l’ASN et vérifiez ses lignes.",
          documentGeneration: "Génération du document impossible.",
          lineCreate: "Ajout impossible. Vérifiez l’article, le conditionnement et la quantité.",
          reopen: "Réouverture impossible.",
          stockCreate: "Création impossible. Vérifiez les points de processus ainsi que les exigences de lot, péremption ou numéro de série.",
          documentHistory: "Historique documentaire indisponible.", templateMissing: "Aucun modèle INBOUND_ASN publié n’est disponible.",
          receiptState: "Cette ASN n’est plus réceptionnable. Son état a été actualisé.", receiptAlreadyOpen: "Une réception est déjà ouverte pour cette ASN.",
          receiptConflict: "Le démarrage de la réception est incompatible avec l’état actuel de l’ASN.", receiptStart: "Impossible de démarrer la réception."
          , receiptComplete: "Impossible de terminer la réception. Chaque ligne doit avoir un conditionnement actif et identifié."
          , poNotFound: "Aucune commande de réapprovisionnement active ne correspond à ce numéro de PO."
        },
        empty: {
          all: "Aucune réception ni aucun ASN n’est encore enregistré.",
          filtered: "Aucun résultat ne correspond aux filtres."
        },
        card: {
          labels: { client: "Client", lines: "Nombre de ligne(s)", status: "Statut", type: "Type de réception", adHoc: "Sans avis d’expédition", line: "Ligne", description: "Désignation", expected: "Quantité attendue", remaining: "Quantité restante" },
          warehouse: "Entrepôt {{code}}",
          expectedAt: "Attendue le {{date}}",
          createdAt: "Créé le {{date}}",
          detailsAria: "Afficher le détail de la réception",
          adHocMeta: "Réception ad hoc · entrepôt {{warehouse}} · motif {{reason}}"
        },
        filters: { id: "ID / numéro", supplier: "Fournisseur", warehouse: "Entrepôt",
          sortDate: "Date de tri", createdAt: "Date de création", expectedArrival: "Arrivée prévue",
          order: "Ordre" },
        fields: { asnNumber: "Numéro ASN", receiptNumber: "Numéro de réception",
          supplier: "Fournisseur", stockOwner: "Propriétaire du stock", warehouse: "Entrepôt",
          purchaseOrder: "Commande d’achat", externalReference: "Référence externe",
          expectedArrival: "Arrivée prévue", customsRequired: "Dédouanement requis",
          reason: "Motif", comment: "Commentaire justificatif", item: "Article",
          packaging: "Conditionnement", quantity: "Quantité", expectedExpiry: "Péremption attendue",
          customsReference: "Référence douanière / MRN", decision: "Décision",
          received: "Reçu", accepted: "Accepté", rejected: "Rejeté", quarantine: "Quarantaine",
          expiry: "Péremption", correctionReason: "Motif de correction", broker: "Transitaire",
          baseUnit: "Unité de base", expectedLot: "Lot attendu", lot: "Lot", uom: "UOM", commentShort: "Commentaire" },
        labels: { client: "Client {{name}}", customs: "Dédouanement", customsRequired: "Dédouanement requis",
          poPrefilled: "Champs proposés depuis la commande. Vous pouvez les corriger avant la création.", poSupplierMissing: "Le fournisseur doit être sélectionné manuellement.",
          documentSize: "{{size}} Ko", reason: "Motif : {{reason}}" },
        numbering: { automatic: "Génération automatique",
          preview: "Aperçu non réservé ; le numéro définitif est attribué à la création.",
          previewConcurrent: "Aperçu non réservé ; le numéro final peut diverger en cas de concurrence.",
          manual: "Saisie manuelle selon la configuration active.", loading: "Chargement de la numérotation…",
          unavailable: "Politique de numérotation indisponible.", unavailableAdmin: "Politique de numérotation indisponible. Contactez un administrateur.",
          manualRequired: "Numéro manuel obligatoire." },
        adHoc: { title: "Créer une réception ad hoc",
          warning: "Cette réception n’est rattachée à aucun ASN. Le motif et le commentaire sont obligatoires et seront audités.",
          reasons: { UNPLANNED_DELIVERY: "Livraison non annoncée", ERP_UNAVAILABLE: "ERP indisponible",
            EMERGENCY: "Réception urgente", OTHER: "Autre" } },
        sections: { expectedLines: "Lignes attendues", receipts: "Réceptions", documents: "Documents ({{count}})",
          audit: "Audit ({{count}})", recordedMovements: "Mouvements enregistrés",
          receiveQuantity: "Réceptionner une quantité", stockUnits: "Stock et unités logistiques" },
        quantities: { received: "Reçu {{received}} {{uom}} · accepté {{accepted}}",
          quarantined: " · quarantaine {{count}}", rejected: " · rejeté {{count}}",
          expected: "Attendu {{expected}} {{uom}} · reçu {{received}} · reste {{remaining}}",
          lot: " · lot {{lot}}", noneReceived: "Aucune quantité n’est encore réceptionnée.",
          expectedAlready: "Attendu {{expected}} {{uom}} · déjà reçu {{received}}" },
        emptyDetails: { lines: "Aucune ligne n’est encore définie.", documents: "Aucun document généré.",
          generatedDocuments: "Aucun document n’a encore été généré pour cet ASN." },
        customs: { control: "Contrôle douanier · {{number}}", commercialInvoice: "Facture commerciale présente : {{value}}",
          packingList: "Packing list présente : {{value}}", origin: "Origine renseignée : {{value}}",
          physicalControl: "Contrôle physique réalisé : {{value}}", yes: "Oui", no: "Non",
          decisions: { RELEASED: "Mainlevée accordée", ADDITIONAL_INFO_REQUIRED: "Complément requis", REFUSED: "Refusée" } },
        receipt: { title: "Réception {{number}}", linesCount: "{{count}} ligne(s)",
          correctionMode: "Mode correction actif · motif audité : {{reason}}",
          unknownPackaging: "UNKNOWN · À identifier avant la mise en stock",
          serializedHelp: "Article sérialisé : saisissez ou scannez un numéro unique par unité, séparé par une ligne, une virgule ou un point-virgule.",
          serialMismatch: "Le nombre de séries uniques doit correspondre exactement aux quantités acceptées, rejetées et mises en quarantaine.",
          quantityMismatch: "La somme accepté + rejeté + quarantaine doit être égale au reçu{{limit}}.",
          withoutExceeding: ", sans dépasser le reliquat", stockPending: "Le stock n’est pas encore comptabilisé. Les quantités acceptées, en quarantaine et rejetées seront séparées dans des HU distinctes.",
          noReceivingPoint: "Aucun point de réception actif n’est configuré pour cet entrepôt.",
          acceptedPoint: "Point de réception — accepté", rejectedPoint: "Point qualité — rejeté",
          quarantinePoint: "Point de quarantaine", asnLine: "Ligne ASN", remaining: "reste",
          serialAccepted: "Séries acceptées ({{current}}/{{expected}})", serialRejected: "Séries rejetées ({{current}}/{{expected}})",
          serialQuarantined: "Séries en quarantaine ({{current}}/{{expected}})", delete: "Supprimer",
          deleteError: "Suppression impossible.", saveError: "Enregistrement impossible.", activateCorrection: "Activer le mode correction",
          correct: "Corriger", leaveCorrection: "Quitter la correction",
          auditReason: "Le motif sera conservé dans l’audit avec votre identité.", reasonHelper: "Obligatoire — minimum 3 caractères." }
      }
    }
  },
  en: {
    translation: {
      common: {
        pageActions: "Page actions", backAction: "Back", secondaryAction: "Secondary action", additionalAction: "Additional action", searchIn: "Search in {{module}}", filtersAction: "Filters",
        home: "Home",
        source: "Source",
        destination: "destination",
        destinationLabel: "Destination",
        equipment: "equipment",
        client: "customer",
        clientLabel: "Customer",
        actions: {
          cancel: "Cancel",
          close: "Close",
          retry: "Retry",
          reconnect: "Sign in again",
          continue: "Continue",
          start: "Start",
          collapse: "Collapse",
          save: "Save",
          reject: "Reject",
          approve: "Approve"
        },
        filters: {
          search: "Search",
          all: "All",
          ascending: "Ascending",
          descending: "Descending"
        },
        language: { menu: "Language", french: "Français", english: "English" },
        line: "{{count}} line",
        line_other: "{{count}} lines"
      },
      allocation: allocationResources.en,
      administration: administrationResources.en,
      configuration: configurationResources.en,
      masterData: masterDataResources.en,
      delivery: deliveryResources.en,
      handlingEquipment: handlingEquipmentResources.en,
      inventory: inventoryResources.en,
      preparation: preparationResources.en,
      status: {
        WAITING_TRANSFER: "Waiting for transfer",
        IN_PROGRESS: "In progress",
        TRANSFERRED: "Transferred",
        COMPLETED: "Completed",
        COMPLETED_WITH_INCIDENT: "Completed with incident",
        CANCELLED: "Cancelled",
        EXCEPTION: "Exception",
        OPEN: "Open",
        CREATED: "Created",
        ASSIGNED: "Assigned",
        LOADING: "To load",
        READY: "Ready",
        PENDING: "Pending",
        RECEIVED: "Received",
        CLOSED: "Closed",
        EXPECTED: "Expected",
        CUSTOMS_PENDING: "Customs clearance",
        ARRIVED: "Arrived",
        RECEIVING: "Receiving",
        POSTING: "To post",
        EXPIRED: "Expired",
        PROPOSED: "Proposed",
        DRAFT: "Draft",
        ALLOCATED: "Allocated",
        SUBMITTED: "Submitted",
        ATP_AVAILABLE: "Stock available",
        ATP_FAILED: "Stock unavailable",
        FAILED: "Failed",
        PROCESSING: "In progress",
        ACTIVE: "Active",
        AVAILABLE: "Available",
        IN_USE: "In use",
        MAINTENANCE: "Maintenance",
        OUT_OF_SERVICE: "Out of service",
        NO_DESTINATION: "No destination",
        ARCHIVED: "Archived",
        PUBLISHED: "Published",
        TO_RESOLVE: "To remediate",
        PENDING_APPROVAL: "Pending approval",
        REMEDIATION: "Under remediation"
      },
      putaway: putawayResources.en,
      quality: qualityResources.en,
      repackaging: repackagingResources.en,
      stock: stockResources.en,
      transverse: transverseResources.en,
      warehouse: warehouseResources.en,
      outboundOrder: outboundOrderResources.en,
      dashboard: dashboardResources.en,
      documents: documentResources.en,
      translationAdmin: translationAdminResources.en,
      inbound: {
        module: "Receiving",
        title: "Receipts",
        tabs: { open: "Open tasks", closed: "Closed tasks" },
        tabsMobile: { open: "OPEN", closed: "CLOSED" },
        searchPlaceholder: "ASN, receipt, supplier, customer, warehouse, purchase order or status…",
        receiptStatus: {
          OPEN: "Open", POSTING: "To post",
          COMPLETED: "Closed", CANCELLED: "Cancelled"
        },
        actions: {
          adHoc: "Ad hoc receipt",
          newAsn: "New ASN",
          createAsn: "Create ASN",
          markExpected: "Mark as expected",
          markArrival: "Confirm receipt",
          takeCharge: "Take charge",
          customsRejected: "Customs clearance rejected",
          enterDecision: "Enter decision",
          closeAsn: "Close ASN",
          view: "View", select: "Select", create: "Create", createAndReceive: "Create and receive",
          continueReceipt: "Continue receiving", editLines: "Edit lines", operations: "Actions and operations",
          addLine: "Add a line", addTheLine: "Add line", generateDocument: "ASN document", generating: "Generating…",
          cancelAsn: "Cancel ASN", takeCustoms: "Take charge of customs clearance", validateDecision: "Validate decision",
          download: "Download", saveQuantity: "Save quantity", createStock: "Create stock and HUs",
          finishReceipt: "Complete receipt", reopen: "Reopen receipt", reopenForCorrection: "Reopen receipt for correction"
          , findPo: "Find PO"
        },
        errors: {
          load: "Unable to load expected receipts.",
          statusChange: "The ASN status change failed. Refresh the list and try again.",
          lines: "Unable to load line details.", partialDetails: "Some details could not be loaded.",
          documentOpen: "Unable to open the document.", asnCreate: "Unable to create. Check the number, supplier and warehouse.",
          adHocCreate: "Unable to create. Check the supplier, warehouse, number and reason.",
          transition: "Transition unavailable. Reload the ASN and check its lines.", documentGeneration: "Unable to generate the document.",
          lineCreate: "Unable to add. Check the material, packaging and quantity.", reopen: "Unable to reopen the receipt.",
          stockCreate: "Unable to create. Check process points and lot, expiry or serial-number requirements.",
          documentHistory: "Document history unavailable.", templateMissing: "No published INBOUND_ASN template is available.",
          receiptState: "This ASN can no longer be received. Its status has been refreshed.", receiptAlreadyOpen: "A receipt is already open for this ASN.",
          receiptConflict: "Starting the receipt is incompatible with the current ASN status.", receiptStart: "Unable to start the receipt."
          , receiptComplete: "Unable to complete the receipt. Every line must have an identified active packaging."
          , poNotFound: "No active replenishment order matches this PO number."
        },
        empty: {
          all: "No receipt or ASN has been recorded yet.",
          filtered: "No result matches the filters."
        },
        card: {
          labels: { client: "Customer", lines: "Number of line(s)", status: "Status", type: "Receipt type", adHoc: "Without shipping notice", line: "Line", description: "Description", expected: "Expected quantity", remaining: "Remaining quantity" },
          warehouse: "Warehouse {{code}}",
          expectedAt: "Expected on {{date}}",
          createdAt: "Created on {{date}}",
          detailsAria: "Show receipt details", adHocMeta: "Ad hoc receipt · warehouse {{warehouse}} · reason {{reason}}"
        },
        filters: { id: "ID / number", supplier: "Supplier", warehouse: "Warehouse", sortDate: "Sort date",
          createdAt: "Creation date", expectedArrival: "Expected arrival", order: "Order" },
        fields: { asnNumber: "ASN number", receiptNumber: "Receipt number", supplier: "Supplier",
          stockOwner: "Stock owner", warehouse: "Warehouse", purchaseOrder: "Purchase order",
          externalReference: "External reference", expectedArrival: "Expected arrival", customsRequired: "Customs clearance required",
          reason: "Reason", comment: "Supporting comment", item: "Material", packaging: "Packaging", quantity: "Quantity",
          expectedExpiry: "Expected expiry", customsReference: "Customs reference / MRN", decision: "Decision",
          received: "Received", accepted: "Accepted", rejected: "Rejected", quarantine: "Quarantine",
          expiry: "Expiry", correctionReason: "Correction reason", broker: "Customs broker", baseUnit: "Base unit",
          expectedLot: "Expected lot", lot: "Lot", uom: "UOM", commentShort: "Comment" },
        labels: { client: "Customer {{name}}", customs: "Customs clearance", customsRequired: "Customs clearance required",
          poPrefilled: "Fields suggested from the purchase order. You can correct them before creation.", poSupplierMissing: "The supplier must be selected manually.",
          documentSize: "{{size}} KB", reason: "Reason: {{reason}}" },
        numbering: { automatic: "Automatic generation", preview: "Non-reserved preview; the final number is assigned upon creation.",
          previewConcurrent: "Non-reserved preview; the final number may differ in case of concurrent creation.", manual: "Manual entry according to the active configuration.",
          loading: "Loading numbering…", unavailable: "Numbering policy unavailable.",
          unavailableAdmin: "Numbering policy unavailable. Contact an administrator.", manualRequired: "Manual number required." },
        adHoc: { title: "Create an ad hoc receipt", warning: "This receipt is not linked to an ASN. The reason and comment are required and will be audited.",
          reasons: { UNPLANNED_DELIVERY: "Unannounced delivery", ERP_UNAVAILABLE: "ERP unavailable", EMERGENCY: "Urgent receipt", OTHER: "Other" } },
        sections: { expectedLines: "Expected lines", receipts: "Receipts", documents: "Documents ({{count}})", audit: "Audit ({{count}})",
          recordedMovements: "Recorded movements", receiveQuantity: "Receive a quantity", stockUnits: "Stock and handling units" },
        quantities: { received: "Received {{received}} {{uom}} · accepted {{accepted}}", quarantined: " · quarantined {{count}}",
          rejected: " · rejected {{count}}", expected: "Expected {{expected}} {{uom}} · received {{received}} · remaining {{remaining}}",
          lot: " · lot {{lot}}", noneReceived: "No quantity has been received yet.", expectedAlready: "Expected {{expected}} {{uom}} · already received {{received}}" },
        emptyDetails: { lines: "No line has been defined yet.", documents: "No document generated.", generatedDocuments: "No document has been generated for this ASN yet." },
        customs: { control: "Customs control · {{number}}", commercialInvoice: "Commercial invoice present: {{value}}",
          packingList: "Packing list present: {{value}}", origin: "Origin provided: {{value}}", physicalControl: "Physical inspection performed: {{value}}",
          yes: "Yes", no: "No", decisions: { RELEASED: "Released", ADDITIONAL_INFO_REQUIRED: "Additional information required", REFUSED: "Refused" } },
        receipt: { title: "Receipt {{number}}", linesCount: "{{count}} line(s)", correctionMode: "Correction mode active · audited reason: {{reason}}",
          unknownPackaging: "UNKNOWN · Must be identified before putaway", serializedHelp: "Serialized material: enter or scan one unique number per unit, separated by a line, comma or semicolon.",
          serialMismatch: "The number of unique serial numbers must exactly match accepted, rejected and quarantined quantities.",
          quantityMismatch: "Accepted + rejected + quarantined must equal received{{limit}}.", withoutExceeding: ", without exceeding the remaining quantity",
          stockPending: "Stock has not been posted yet. Accepted, quarantined and rejected quantities will be separated into distinct HUs.",
          noReceivingPoint: "No active receiving point is configured for this warehouse.", acceptedPoint: "Receiving point — accepted",
          rejectedPoint: "Quality point — rejected", quarantinePoint: "Quarantine point", asnLine: "ASN line", remaining: "remaining",
          serialAccepted: "Accepted serials ({{current}}/{{expected}})", serialRejected: "Rejected serials ({{current}}/{{expected}})",
          serialQuarantined: "Quarantined serials ({{current}}/{{expected}})", delete: "Delete", deleteError: "Unable to delete.",
          saveError: "Unable to save.", activateCorrection: "Enable correction mode", correct: "Correct", leaveCorrection: "Exit correction",
          auditReason: "The reason will be stored in the audit with your identity.", reasonHelper: "Required — at least 3 characters." }
      }
    }
  }
} as const;

function applyBaseline(language: "fr" | "en") {
  const catalog = resources[language].translation as unknown as Record<string, unknown>;
  Object.entries(baselineTranslations[language]).forEach(([flatKey, value]) => {
    const segments = flatKey.split(".");
    let target = catalog;
    segments.slice(0, -1).forEach((segment) => {
      const current = target[segment];
      if (!current || typeof current !== "object") target[segment] = {};
      target = target[segment] as Record<string, unknown>;
    });
    target[segments.at(-1)!] = value;
  });
}

applyBaseline("fr");
applyBaseline("en");

export type SupportedLanguage = keyof typeof resources;
